import React, { useEffect, useState } from 'react';
import ComAddGrpPopup from './ComAddGrpPopup';
import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';

function ComGrpSearchSpan({ handleTaggedStaff }) {
  const [addGrpPopup, setAddGrpPopup] = useState(false);
  const [dropDownGrpVal, setDropDownGrpVal] = useState('');
  const [grpsArr, setGrpsArr] = useState([]);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/communication/Communication/getTaggedUserList',
          {}
        );
        if (response?.status === 200) {
          setGrpsArr(response?.data);
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [reload]);

  const handleReload = () => {
    setReload(!reload);
  };

  return (
    <div>
      <div
        className="comp-msg-bdy-rw grid-sec"
        style={{ position: 'relative' }}
      >
        <div className="comp-msg-bdy-chld-rw flex-sec">
          <span className="msg-bdy-rw-bl">Group:</span>
          <span className="msg-bdy-rw-val">
            <select
              className="comm-filter width80"
              onChange={(e) => {
                if (e.target.value) {
                  for (const grpObj of grpsArr) {
                    if (grpObj?.id === e.target.value) {
                      setDropDownGrpVal(grpObj?.id);
                      // Split the tag_user string into an array of numbers
                      const tagUsers =
                        grpObj.tag_user ? grpObj.tag_user.split(',') : [];
                      // Create the array of objects with staffName and staff_id properties
                      const taggedUserArray = tagUsers.length > 0  && tagUsers.map(
                        (tagUserId, index) => ({
                          staffName: grpObj.tag_user_name[index],
                          staff_id: tagUserId,
                        }),
                      );
                      handleTaggedStaff(taggedUserArray);
                    }
                  }
                } else {
                  setDropDownGrpVal('');
                  handleTaggedStaff([]);
                }
              }}
              value={dropDownGrpVal}
            >
              <option value={''}></option>
              {grpsArr &&
                grpsArr.length > 0 &&
                grpsArr.map((item, i) => {
                  return (
                    <option key={item?.id} value={item?.id}>
                      {item?.group_name}
                    </option>
                  );
                })}
            </select>
            <span className="add-nw-tmplt" onClick={() => setAddGrpPopup(true)}>
              +
            </span>
          </span>
        </div>
      </div>
      {addGrpPopup && (
        <ComAddGrpPopup
          grpsArr={grpsArr}
          handleReload={handleReload}
          close={() => setAddGrpPopup(false)}
        />
      )}
    </div>
  );
}

export default ComGrpSearchSpan;
